// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3OI5u","text":"SelectPayment_text__12DBg","title":"SelectPayment_title__sQzD6","btn":"SelectPayment_btn__1kkuN"};